import { templateThemeTokens } from './templateThemeTokens.js';
import { THEME_DEFAULT_FONTS } from '@/contexts/CustomThemeConfigContext/constants.js';
import { createTheme } from '@/stitches/index.js';

export const dawn = createTheme({
  ...templateThemeTokens,
  colors: {
    defaultFont: '#000000',
    pageBackground: '#FAF8FF',
    secondaryFont: '#6A57E3',
  },
  fonts: {
    accent: THEME_DEFAULT_FONTS.paris.dawn.accent
      ? THEME_DEFAULT_FONTS.paris.dawn.accent.value
      : 'unset',
    body: THEME_DEFAULT_FONTS.paris.dawn.body.value,
    heading: THEME_DEFAULT_FONTS.paris.dawn.headline.value,
  },
  fontWeights: {
    body: 400,
    heading: 400,
  },
});
